/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tickets': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M16.562 11.349l-.62-.62.706-.708.62.62 1.362-1.36a.5.5 0 0 0 0-.708l-6.829-6.828a.5.5 0 0 0-.707 0L9.733 3.106l.647.647-.707.707-.647-.647-7.154 7.155v1.362h1.06a1 1 0 0 1 1 1v1.06h1.055a1 1 0 0 1 1 1v1.054h1.06a1 1 0 0 1 1 1v1.06h1.361l7.154-7.155zm-7.154 8.155H8.046a1 1 0 0 1-1-1v-1.06H5.987a1 1 0 0 1-1-1V15.39H3.933a1 1 0 0 1-1-1v-1.06h-1.06a1 1 0 0 1-1-1v-1.362a1 1 0 0 1 .292-.707l9.222-9.224a1.5 1.5 0 0 1 2.122 0l6.828 6.83a1.5 1.5 0 0 1 0 2.12l-9.222 9.224a1 1 0 0 1-.707.293zm.718-14.59l.707-.708 1 1-.706.708-1.001-1zm1.454 1.453l.707-.707 1 1-.707.708-1-1zm1.454 1.454l.707-.707 1 1-.707.707-1-1zm1.453 1.454l.707-.707 1.001 1-.707.707-1-1z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/tickets.js